import { FormikHelpers } from "formik";
import { useCreateAtm } from "./api/createAtm";
import CreateAtmForm from "./CreateAtmForm";


const CreateAtm = ({handleCloseModal}: CreateAtmProps)  => {
  const createAtmMutation = useCreateAtm({data: {}});

  const initialValues: ICreateAtmForm = {
    atmTerm: "",
    atmAddress: "",
    connMethod: "",
    atmHost: "",
    unitID: "",
    linetypeID: "",
    modemID: "",
    atmModelID: "",
    contact: "",
    atmTypeID: "",
    atmCompany: "",
    isEmporiki: false,
    isCiti: false,
    deleted: false,
    description: ""
  };

  const handleSubmit = async (values: ICreateAtmForm, { setSubmitting }: FormikHelpers<ICreateAtmForm>): Promise<void> => {
    try {
      await createAtmMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <CreateAtmForm initialValues={initialValues}  onSubmit={handleSubmit} />
  )
}

interface CreateAtmProps {
  handleCloseModal: () => void;
}

export default CreateAtm;